import Config from "../Config";


import imgClients  from "../clients.png"
import imgInvoices  from "../invoice.png"
import imgRaports  from "../raports.png"
import imgSettings  from "../settings.png"


function MenuLeft(props)
{
        var module = props.mainView.menuSelected;
        var view   = props.mainView.viewSelected;
        var id     = props.mainView.idSelected;


        if(Config.env == 'dev') console.log("MenuLeft, module: " + module + ", view: " + view + ", id: " + id);


        var cssModuleStart     = "";
        var cssModuleClient    = "";
        var cssModuleCalculate = "";
        var cssModuleRaports   = "";


        if(module == "home")       cssModuleStart     = "selected";
        if(module == "client")     cssModuleClient    = "selected";
        if(module == "calculate")  cssModuleCalculate = "selected";
        if(module == "raport")     cssModuleRaports   = "selected";


        var menuTree = [

            {
                module: 'home',
                title: 'Klienci i umowy',
                css: 'li_sub',
                img: imgClients,

                subs: [
                      //   { view: 'start',  title: 'Start', css: '',}, 
                         { view: 'clients',  title: 'Baza klientów [k]', css: '',}, 
                         { view: 'contracts',  title: 'Umowy [u]', css: '',}, 
                         { view: 'services',  title: 'Usługi [s]', css: '',}, 
                         { view: 'locks',  title: 'Blokady [b]', css: '',}, 
                ]
            },

            {
                module: 'calculate',
                title: 'Rozliczenia i faktury',
                css: 'li_sub',
                img: imgInvoices,

                subs: [
                         { view: 'invoices',  title: 'Faktury [f]', css: '',},                      
                         { view: 'transfers',  title: 'Przelewy [p]', css: '',},                      
                         { view: 'calculate',  title: 'Rozliczenia [r]', css: '',},                      
                         { view: 'history',  title: 'Historia salda [h]', css: '',},                      
                        // { view: 'req_to_pay',  title: 'Wezwania do zapłaty [w]', css: '',},                      
                ]
            },


             {
                module: 'raport',
                title: 'Raporty i wykresy',
                css: 'li_sub',
                img: imgRaports,

                subs: [
                         { view: 'sum',  title: 'Podsumowanie', css: '',},                                                    
                         { view: 'rp1',  title: 'Rap. okresowy ', css: '',},                                                                         
                         { view: 'export',  title: 'Export danych', css: '',},                                                    
                ]
            },

             {
                module: 'settings',
                title: 'Ustawienia',
                css: 'li_sub',
                img: imgSettings,

                subs: [
                         { view: 'account',  title: 'Moje konto', css: '',},                                                    
                ]
            },


        ];


        //set css for selected position

        for(var k=0; k < menuTree.length; k++)
        {
                if(menuTree[k].module == module) {
                   menuTree[k].css = "li_sub selected";

                   for(var w=0; w < menuTree[k].subs.length; w++)
                   {
                       if(menuTree[k].subs[w].view == view ) {
                            menuTree[k].subs[w].css = "selected";
                       }
                   }

                }
        }




        return <div className="menu_left" >

                    <ul className="ul_top">

                        {
                            menuTree.map( (mainMenu, mmInx) => {
                                 return <li key={mmInx} className={mainMenu.css}     atr-n={mainMenu.module}  module={mainMenu.module} view={mainMenu.subs[0].view} id="-1"   onClick={props.mainView.quickGo}  >
                                            <div className="mTitle" ><img src={mainMenu.img} />{mainMenu.title}</div> 
                                            <ul className="ul_sub">
                                                {
                                                    mainMenu.subs.map( (subMenu, subInx) => {

                                                        return <li key={subInx}  className={subMenu.css} module={mainMenu.module} view={subMenu.view} id="-1" onClick={props.mainView.quickGo}  >{subMenu.title}</li>

                                                    } )
                                                }
                                            </ul>                                           
                                 </li>
                            } )
                        }

                       
                    </ul>

                    <div className="menu_tips">
                        Skróty klawiszowe: <br/>
                        Shift + [f]  - idź do faktur <br/>
                        Shift + [q]  - wyloguj <br/>
                        Esc  - wyczyść filtry <br/>
                        Backslash  - wróć / wyjdź <br/>
                        Right  - następna strona <br/>
                        Left  - poprzednia strona <br/>
                        Ctrl + s -zapis danych w formularzu <br/>
                    </div>
        </div>
}


export default MenuLeft;